import { Controller, Menu } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { MENU_CONFIGS } from './config';
import { ExitDocumentFeature } from './exit-document-feature';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

const exitDocument = setDefaultConfig(appConfigInstance.getConfig(ToolbarFileMenuConfig.exitDocument as any), false);

@Controller({ menuItems: MENU_CONFIGS })
export class ExitDocumentController {
    public constructor(private readonly feature: ExitDocumentFeature) {
    }

    @Menu(ActionType.EXIT_DOCUMENT, 'onClick')
    public clickExitDocument() {
        this.feature.clickExitDocument();
    }

    @Menu(ActionType.EXIT_DOCUMENT, 'shouldHide')
    public shouldHide() {
        return !exitDocument; // 目前saas与私有化专用
    }
}
